module.exports = __webpack_public_path__ + "img/Simpas_Applied_Solutions.f8888498.svg";